import PropTypes from 'prop-types';
import React from 'react';
import { RenderComponents } from '../../helpers/lazyRender';

// TODO: here I may need to load data, etc...
// use this config: `componentConfig`
const SidePanel = ({ className, /* componentConfig, */ componentStyles, inheritedStyles, components }) => (
  <div className={className || null} style={componentStyles || inheritedStyles || null}>
    {components && <RenderComponents components={components} />}
  </div>
);

SidePanel.propTypes = {
  className: PropTypes.string,
  // componentConfig: PropTypes.object,
  componentStyles: PropTypes.object,
  inheritedStyles: PropTypes.object,
  components: PropTypes.array,
};

export default SidePanel;
